/* import __COLOCATED_TEMPLATE__ from './bias-non-inverting.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();